<article class="d-flex flex-column align-self-center mx-3 h-100">

    <section class="d-flex flex-column justify-content-center flex-grow-1 w-100">
        <div class="text-center">
            <svg class="mx-auto" width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="29" cy="28" r="24" fill="#FF4B4B"/>
                <path d="M21.4583 35.5416L36.5433 20.4567" stroke="white" stroke-width="3.42857" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M36.5417 35.5416L21.4567 20.4567" stroke="white" stroke-width="3.42857" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
            <div class="mt-4 mb-4" *ngIf="currentError$ | async as currentError;">
                <h2 class="error-msg error-msg-title fw-bold">{{ currentError.message.title }}</h2>
                <h5 class="error-msg error-msg-subtitle fw-normal mt-2">{{ currentError.message.subtitle }}</h5>
            </div>
        </div>
    </section>

    <div class="button-container w-100 mt-auto" *ngIf="currentError$ | async as currentError;">
        <div class="row w-100 mx-auto mb-3">
            <button
                type="submit"
                class="cc-submit-btn cc-submit-btn-secondary w-100"
                mat-flat-button
                (click)="submitGoHomeApp(currentError.getErrorUrl())"
            >
                Ir a inicio
            </button>
        </div>  
        
        <div class="row w-100 mx-auto mb-4" *ngIf="currentError.withRetryBtn">
            <button
                type="submit"
                class="cc-submit-btn w-100"
                mat-flat-button
                (click)="submitRetry()"
            >
                Reintentar
            </button>
        </div>
    </div>
</article>